module.exports = __webpack_public_path__ + "static/media/createAssignTemplate2.6b93d9db.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Instructions/createAssignTemplate2.gif
// module id = 1252
// module chunks = 2